import Model from '@/lib/data/Model';
import Representative from './Representative';
import Address from './Address';
import CustomerGroup from './CustomerGroup';
import Visit from './Visit'; // eslint-disable-line
import InsPolicy from './uw/InsPolicy';
import Account from './Account';

class Customer extends Model {
    static idProperty = 'id';

    fields = [
        { name: 'id' },
        { name: 'name' },
        { name: 'customer_code' },
        { name: 'record_state', type: 'int', defaultValue: 1 },
        {
            name: 'representative',
            mapping: 'representative_id',
            association: {
                type: 'one',
                model: Representative,
            },
        },
        {
            name: 'group',
            mapping: 'group_id',
            association: {
                type: 'one',
                model: CustomerGroup,
            },
        },
        {
            name: 'addresses',
            association: {
                type: 'many',
                model: Address,
            },
        },
        {
            name: 'visits',
            association: {
                type: 'many',
                model: Visit,
            },
        },
        {
            name: 'shared',
            type: 'bool',
            defaulValue: false,
        },
        {
            name: 'organization_id',
        },
        {
            name: 'customer_type',
            defaultValue: 'VRS',
        },
        {
            name: 'contact_email',
        },
        {
            name: 'contact_phone',
        },
        {
            name: 'subscribed',
            type: 'bool',
            defaultValue: true,
        },
        {
            name: 'inspolicies',
            association: {
                type: 'many',
                model: InsPolicy,
            },
        },
        {
            name: 'account',
            association: {
                type: 'one',
                model: Account,
            },
        },
        { name: 'client_type' },
        { name: 'currency_id' },
        { name: 'policy_no' },
        { name: 'broker_id' },
        { name: 'partner_id' },
        { name: 'consultant_id' },
        { name: 'director_id' },
        { name: 'underwriter_id' },
    ];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }

    get addressInfo() {
        const { addresses } = this;
        let addressInfo = '';

        if (Array.isArray(addresses) && addresses.length > 0) {
            const head = addresses.find((item) => !!item.head_office);
            const [firstAddress] = addresses;
            const address = head || firstAddress;
            addressInfo = address.address_text || address.street1;
        }

        return addressInfo;
    }

    get addressInfoAll() {
        const { addresses } = this;
        let addressInfoAll = '';

        if (Array.isArray(addresses) && addresses.length > 0) {
            [...addresses]
                .sort((a, b) => Number(b.head_office) - Number(a.head_office))
                .slice(0, 10)
                .forEach((item) => {
                    addressInfoAll += `- ${item.address_text || item.street1}\n`;
                });
        }

        return addressInfoAll;
    }

    get isShared() {
        return this.shared == 1;
    }

    get isActive() {
        return this.record_state == 1;
    }

    get filledAddresses() {
        return this.addresses.filter((addr) => addr.address_text || addr.street1);
    }

    api = [
        {
            name: 'get',
            url: '/customer/get',
            params: ['id'],
        },
        {
            name: 'create',
            method: 'POST',
            url: '/customer/save',
            associated: {
                representative: false,
                addresses: true,
                group: false,
                account: true,
            },
            params: [
                'id',
                'name',
                'customer_code',
                'shared',
                'representative_id',
                'group_id',
                'addresses',
                'organization_id',
                'customer_type',
                'contact_email',
                'contact_phone',
                'subscribed',
                'record_state',
                'account',
                'client_type',
                'currency_id',
                'policy_no',
                'broker_id',
                'partner_id',
                'consultant_id',
                'director_id',
                'underwriter_id',
            ],
        },
        {
            name: 'update',
            method: 'POST',
            url: '/customer/save',
            associated: {
                representative: false,
                addresses: true,
                group: false,
                account: true,
            },
            params: [
                'id',
                'name',
                'customer_code',
                'shared',
                'representative_id',
                'group_id',
                'addresses',
                'organization_id',
                'tag_id',
                'customer_type',
                'contact_email',
                'contact_phone',
                'subscribed',
                'record_state',
                'account',
                'client_type',
                'currency_id',
                'policy_no',
                'broker_id',
                'partner_id',
                'consultant_id',
                'director_id',
                'underwriter_id',
            ],
        },
        {
            name: 'delete',
            url: '/customer/delete',
            params: ['id'],
        },
        {
            name: 'setInactive',
            url: '/customer/inactive',
            params: ['id'],
        },
        {
            name: 'checkRelativity',
            url: '/customer/relativity/search',
            params: ['name', 'address'],
        },
        {
            name: 'createWithoutAddress',
            method: 'POST',
            url: '/customer/savenoaddress',
            associated: {
                representative: false,
                addresses: true,
                group: false,
                account: true,
            },
            params: [
                'id',
                'name',
                'customer_code',
                'shared',
                'representative_id',
                'group_id',
                'addresses',
                'organization_id',
                'customer_type',
                'contact_email',
                'contact_phone',
                'subscribed',
                'record_state',
                'account',
                'micro_list_id',
            ],
        },
    ];
}

export default Customer;
